module.exports = __webpack_public_path__ + "img/type15.7df24c52.png";